var React = require("react");
var { withNamespaces } = require('react-i18next');
var NoChallengeTabs = require('./no_challenge_tab.jsx');

var NoChallenges = React.createClass({
  PropTypes: {
    systemAvailability : React.PropTypes.object.isRequired,
    advocateRewardsPath : React.PropTypes.object.isRequired,
    editProfilePath : React.PropTypes.object.isRequired,
    hasChallenges : React.PropTypes.bool.isRequired,
    channelCount : React.PropTypes.number.isRequired,
    experienceCount : React.PropTypes.number.isRequired,
    challengeStage : React.PropTypes.string.isRequired,
    changeTab: React.PropTypes.func.isRequired,
    handleChangeTab: React.PropTypes.func.isRequired,
    loadingChallenges : React.PropTypes.bool.isRequired,
    stages: React.PropTypes.object.isRequired
  },

  getDefaultProps : function(){
    return {
      systemAvailability : {},
      advocateRewardsPath : "",
      editProfilePath : "",
      hasChallenges : false,
      channelCount : 0,
      experienceCount : 0,
      challengeStage : "",
      loadingChallenges : true
    }
  },

  render : function(){
    return (
      <div className="no-challenges-to-show">
        {this._showNoChallenges()}
      </div>
    );
  },

  _showNoChallenges : function(){
    if(this.props.challengeStage === "Available"){
      if(!this.props.hasChallenges && this.props.loadingChallenges === false && this.props.experienceCount === 0 && this.props.channelCount === 0) {
        return this._noChallenges();
      }
    } else if(!this.props.hasChallenges !== false && this.props.loadingChallenges === false){
      return this._noChallenges();
    }
  },

  _noChallenges : function(){
    const { props: { challengeStage, t, advocateRewardsPath, changeTab, stages } } = this

    const ChallengeTab = {
      Newest: {
        reward: true,
        title: "There are no new challenges yet",
        msg: 'Check back later!',
      },
      Available: { 
        reward: true,
        title: "You've completed every challenge",
        msg: 'Why not put your points to use?',
      },
      Waiting: { 
        reward: true,
        challenge: true,
        title: "You don't have any challenges pending admin approval",
        msg: 'Try one of these!',
      },
      Later: { 
        reward: true,
        challenge: true,
        title: "You haven't saved any challenges for later",
        msg: 'Try one of these!',
      },
      Completed: { 
        challenge: true,
        title: "You haven't completed any challenges yet",
        msg: 'Complete one today!',
      },
    };
    const { reward, challenge, title, msg } = ChallengeTab[challengeStage];
    const { props: { systemAvailability: { attributes: { rewardsAvailable } } } } = this;

    return <NoChallengeTabs
      i18n={t}
      hasRewardLink={reward}
      hasChallengeLink={challenge}
      title={title}
      msg={msg}
      rewardsAvailable={rewardsAvailable}
      navigateToRewards={() => window.location = advocateRewardsPath()}
      changeTabByIndex={index => changeTab(stages[index].action, index)}
    />
  },

  _rewardsAvailable : function(){
    if(this.props.systemAvailability.attributes.rewardsAvailable){
      return (
        <li className="thing-to-do select-goal">
          <a href="javascript:void(0);" onClick={this._navigateToRewards}>
            <i></i><span>{this.props.t('Select a new goal')}</span>
          </a>
        </li>
      );
    } else {
      return null;
    }
  },

  _navigateToRewards : function(){
    window.location = this.props.advocateRewardsPath();
  }
});

module.exports = withNamespaces('HubFE')(NoChallenges);



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/no_challenges.jsx